/* eslint-disable */
export default {
  ringing: '來電',
  callConnected: '通話已連線',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
